import React from 'react';
import { motion } from 'framer-motion';

// Import images for educational institutes
import MumbaiUniversityImage from '../Images/Mumbai university logo.png';
import HighSchoolImage from '../Images/Kelkar college.jpeg';

const Education = () => {
  const education = [
    {
      institution: "Vivekanand Education Society's Institute Of Technology (VESIT)",
      image: MumbaiUniversityImage, 
      degree: "Bachelor of Engineering in IT",
      duration: "2021 - 2025",
      achievements: "CGPA: 8.73/10, Percentage: 77.25%",
      link:"https://vesit.ves.ac.in/"
    },
    {
      institution: "V.G. Vaze College of Arts, Science and Commerce (autonomous), Mulund",
      image: HighSchoolImage, 
      degree: "High Schooling",
      duration: "2019 - 2021",
      achievements: "Percentage: 88.83%",
      link:"https://vazecollege.net/"
    }
  ];

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-center px-4 md:px-8 lg:px-16" id="work">
      <h1 className="text-2xl md:text-4xl font-bold mb-8">Education</h1>
      <center className="max-w-6xl w-full grid gap-8 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 justify-items-center">
        {education.map((education, index) => (
          <a
            key={index}
            href={education.link}
            target="_blank"
            rel="noopener noreferrer"
            className="text-black"
          >
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-gray-100 p-6 rounded-lg shadow-lg flex flex-col items-center"
            >
              <img src={education.image} alt={`${education.institution} Logo`} className="h-20 w-20 object-contain mb-4" />
              <h2 className="text-lg md:text-xl font-semibold">{education.institution}</h2>
              <p className="text-gray-700 text-center">{education.degree}</p>
              <p className="text-gray-700 text-center">{education.duration}</p>
              <p className="text-gray-700 text-center">{education.achievements}</p>
            </motion.div>
          </a>
        ))}
      </center>
    </div>
  );
  
};

export default Education;
